import * as React from "react";
import type { SVGProps } from "react";
const SvgMagnifier = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 10c0 4.41 3.59 8 8 8a7.96 7.96 0 0 0 4.9-1.68l5.39 5.39c.199.189.447.289.705.29h-.005.01-.005a.996.996 0 0 0 .705-1.7l-5.39-5.39A7.96 7.96 0 0 0 18 10c0-4.41-3.59-8-8-8s-8 3.59-8 8m2 0c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMagnifier;
